import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import LeftMenu from "../components/LeftMenu";
import Breadcrumbs from "../components/Breadcrumbs";
import { LoadingStatus } from "../features/sessions/models/LoadingStatus";
import { AssistantChatThread } from "../features/assistant-schedule/components/AssistantChatThread";
import { AssistantChatInput } from "../features/assistant-schedule/components/AssistantChatInput";
import { SchedulePlanCard } from "../features/assistant-schedule/components/SchedulePlanCard";
import { PlanResultSummary } from "../features/assistant-schedule/components/PlanResultSummary";
import {
  selectAssistantMessages,
  selectAssistantStatusMessage,
  selectPendingPlan,
  selectPlanResult,
  selectSendStatus,
} from "../features/assistant-schedule/assistant-schedule-slice";
import { sendAssistantMessage } from "../features/assistant-schedule/slice-extensions/assistant-schedule-slice-extension";

export default function AssistantPage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const messages = useAppSelector(selectAssistantMessages);
  const pendingPlan = useAppSelector(selectPendingPlan);
  const result = useAppSelector(selectPlanResult);
  const sendStatus = useAppSelector(selectSendStatus);
  const statusMessage = useAppSelector(selectAssistantStatusMessage);

  const isSending = sendStatus === LoadingStatus.Loading;

  return (
    <section>
      <div className="flex h-full gap-4">
        <LeftMenu />
        <div className="w-full p-4 pb-[120px] lg:px-10 lg:pb-10">
          <div className="lg:max-w-[900px]">
            <Breadcrumbs />
            <div className="space-y-4 py-6">
              <div>
                <h1>{t("assistant.title")}</h1>
                <p className="mt-1 text-grey-50 dark:text-grey-70">{t("assistant.subtitle")}</p>
              </div>

              <AssistantChatThread
                messages={messages}
                thinking={isSending}
                errorMessage={statusMessage}
              />

              {pendingPlan && <SchedulePlanCard plan={pendingPlan} />}
              {result && <PlanResultSummary result={result} />}

              <AssistantChatInput
                disabled={isSending}
                onSend={(text) => dispatch(sendAssistantMessage(text))}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
